export const callTransaction = (contract, method, args, overrides = null) => {
  try {
    return contract[method](...args, { ...overrides });
  } catch (error) {
    return error.message;
  }
};
